/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_THEMES(state, themes) {
    if(themes == 'undefined'){
      state.list = []
    }else{
      //filter only themes that pro = 0
      state.list = themes.filter(function (theme) {
        return theme.pro == 0 || theme.slug == 'uicore-pro';
      });
    }

  },
  SET_CURRENT_THEME(state, theme) {
    state.current = theme
  }
}

